export const LOCAL_STORAGE_TOKENS = "tokens";
export const LOCAL_STORAGE_HIDE_TODAY = "save-the-earth-hide-today";
export const SESSION_STORAGE_HIDE_POPUP = "save-the-earth-hide-popup";
